import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const InsuranceSelector = (state: RootState) => state.insuranceFooter;
export const InsuranceDetailsSelector = getContractBasedDataSelector((state: RootState) => state.insurance);
